import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { PatientGroupsAssignmentsSaveAction } from './PatientGroupsAssignmentsSaveAction';
import { PatientGroupsAssignmentsForm } from './form/PatientGroupsAssignmentsForm';
import { PatientGroupsAssignmentsFormLoader } from './form/PatientGroupsAssignmentsForm.loader';
import { patientGroupsAssignmentsFormInitializer } from './form/PatientGroupsAssignmentsForm.utils';

type PatientGroupsAssignmentsPanelProps = Readonly<{ patientId: Patient['id'] }>;

export const PatientGroupsAssignmentsPanel = (props: PatientGroupsAssignmentsPanelProps): JSX.Element => {
   return (
      <PatientGroupsAssignmentsFormLoader patientId={props.patientId}>
         {({ patientGroups, assignedPatientGroups }) => (
            <PatientGroupsAssignmentsForm
               patientGroups={patientGroups}
               initializer={patientGroupsAssignmentsFormInitializer(assignedPatientGroups)}
            >
               {({ handleSubmit }) => (
                  <PatientGroupsAssignmentsSaveAction patientId={props.patientId} handleSubmit={handleSubmit} />
               )}
            </PatientGroupsAssignmentsForm>
         )}
      </PatientGroupsAssignmentsFormLoader>
   );
};
